import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import BenefitStatement from "./BenefitStatement";
import Statement from "./Statement";
import { loadBenefitSettings } from "actions/benefitStatementActions";
import { Loader, Field, Toolbar, ToolbarSection, Select } from "cxa-components";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const BenefitStatementSwitcher = () => {
  const dispatch = useDispatch();
  const { benefitSettings } = useSelector(state => state.newuiuxBenefits);
  const { clientSettings } = useSelector(state => state.common);
  const [benefitPlanYear, setBenefitPlanYear] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const loadSettings = useCallback(
    (defaultPlanId = null) => {
      setIsLoading(true);
      const action = defaultPlanId ? loadBenefitSettings({ defaultPlanId }) : loadBenefitSettings();
      dispatch(action).finally(() => setIsLoading(false));
    },
    [dispatch]
  );

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  useEffect(() => {
    if (
      benefitSettings &&
      benefitSettings.planYearList &&
      benefitSettings.planYearList.length > 0
    ) {
      const defaultSelected = benefitSettings.planYearList.find(plan => plan.isSelected);
      setBenefitPlanYear(defaultSelected ? defaultSelected.id : benefitSettings.planYearList[0].id);
    }
  }, [benefitSettings]);

  const handlePlanYearChange = e => {
    const newPlanYear = e.target.value;
    loadSettings(newPlanYear);
  };

  const renderPlanYearOptions = () => {
    if (!benefitSettings || !benefitSettings.planYearList) {
      return [];
    }
    return benefitSettings.planYearList.map(plan => (
      <option key={plan.id} value={plan.id}>
        {plan.name}
      </option>
    ));
  };

  const showNewBenefitStatement =
    clientSettings &&
    clientSettings.newUIFlag &&
    benefitSettings &&
    benefitSettings.enableBenefitStatementForNewUIUX;

  if (isLoading) return <Loader />;

  return (
    <div className="apl-benefit-statement">
      <h2>
        <FormattedMessage {...messages.benefitsOverviewDescription} />
      </h2>
      <Toolbar>
        <ToolbarSection>
          <Field
            label={<FormattedMessage {...messages.planYearDescription} />}
            inlineBoxed
            field={Select}
            onChange={handlePlanYearChange}
            value={benefitPlanYear}
          >
            {renderPlanYearOptions()}
          </Field>
        </ToolbarSection>
      </Toolbar>
      {showNewBenefitStatement ? (
        <BenefitStatement planYearId={benefitPlanYear} />
      ) : (
        <Statement planYearId={benefitPlanYear} />
      )}
    </div>
  );
};

export default BenefitStatementSwitcher;



// WEBPACK FOOTER //
// ./components/employee/benefits/BenefitStatementSwitcher.js